import styled, { css } from 'styled-components';
import { Flexer } from '@ontruck/orc';

const colorProps = ({
  color,
  theme: {
    base: { colorSchema },
  },
}) => css`
  color: ${colorSchema[color] || colorSchema.grey900};
`;

const weightProps = ({ bold }) => css`
  ${bold && 'font-weight: 500;'}
`;

const inlineProps = ({ inline = true, woWrap = false }) => css`
  ${inline && 'display: inline;'}
  ${woWrap && 'white-space: nowrap;'}
`;

export default styled(Flexer.Child)`
  ${colorProps}
  ${weightProps}
  ${inlineProps}
`;
